const _jsx_runtime = require('react/jsx-runtime')

module.exports._jsx_runtime = _jsx_runtime
